<template>
  <CommonOverlay class="overlay" v-show="isOpenResult">
    <div class="complete_title">
      <img src="/img/capsule.png" alt="カプセル画像">
      ↓もう一度回す</div>
    <ProductBanner v-if="currentPack && currentPack.id" :packItem="currentPack" class="banner_base" @handleBannerClick="ShowDetail"/>
    <CommonModal v-if="isSkip" class="modal pack-confirm">
      <div>発送商品の選択をスキップしました。</div>
      <div>スキップした商品は獲得履歴から確認できます。</div>
      <RoundButton
        class="bottom_btn"
        @handleRoundBtnClick="goToTopPage"
        backgroundColor="#7f88a0"
      >ガチャ一覧に戻る</RoundButton>
    </CommonModal>
    <CommonModal v-if="!isSkip" class="modal pack-confirm">
      <div class="text">発送希望いただいた商品は、</div>
      <div class="text">土日祝を除く3営業日以内に発送いたします。</div>
      <RoundButton
        class="bottom_btn"
        @handleRoundBtnClick="goToTopPage"
        backgroundColor="#7f88a0"
      >ガチャ一覧に戻る</RoundButton>
    </CommonModal>
  </CommonOverlay>
</template>

<script>
import CommonOverlay from '@/components/atoms/CommonOverlay.vue';
import CommonModal from '@/components/atoms/CommonModal.vue';
import ProductBanner from '@/components/molecules/ProductBanner.vue';
import t from '@/plugins/i18n';
import { mapGetters } from 'vuex';
import RoundButton from '@/components/atoms/RoundButton.vue';

export default {
  name: 'OnceMore',
  mixins: [t],
  components: {
    CommonOverlay,
    ProductBanner,
    RoundButton,
    CommonModal,
  },

  props: {
    skip: {
      type: Boolean,
      default: false,
    },
    isOpenResult: {
      type: Boolean,
    },
    isSkip: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    ...mapGetters({
      currentPack: 'pack/currentPack',
    }),
  },

  methods: {
    ShowDetail(packId, num) {
      if (num) {
        this.$router.push({ path: '/pack-detail', query: { packId, num } });
      } else {
        this.$router.push({ path: '/pack-detail', query: { packId } });
      }
    },
    goToTopPage() {
      this.$router.push('/');
    },
  },
};
</script>
<style lang="scss" scoped>
.overlay {
  z-index: 9;
  flex-direction: column;
  background-color: rgba(63, 72, 97, 0.9);
  overflow-y: auto;
  z-index: 20;
  .complete_title {
    color: $white;
    font-size: 24px;
    font-weight: bold;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    img {
      width: 50px;
    }
  }
  .banner_base {
    width: 420px;
  }
  .pack-confirm {
    width: 420px;
    background-color: $white;
    margin-top: 10px;
    padding: 16px;
    border-radius: 10px;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    color: $black;
    .bottom_btn {
      margin-top: 20px;
      width: 200px;
      padding: 15px 0;
    }
  }
}
@media screen and (max-width: $tabletWidth) {
  .overlay {
    .banner_base {
      width: 370px;
    }
    .pack-confirm {
      width: 370px;
    }
  }
}
</style>
